import { render, staticRenderFns } from "./Starred.vue?vue&type=template&id=97db65a6"
import script from "./Starred.vue?vue&type=script&lang=js"
export * from "./Starred.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports